/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {PopoverDirective} from 'ngx-bootstrap/popover';
import template from './list-select-in-filter.component.html';

@Component({
  standalone: false,
  selector: 'adn-list-select-in-filter',
  template
})
export class ListSelectInFilterComponent implements OnChanges {
  @Input() list: any;
  @Input() field: string;
  @Input() options: string[];
  @Input() allLabel: string;
  @Input() translationKeyPrefix: string;
  @Input() workingField: string;
  @Input() maxCount: number;

  @ViewChild('filterPopoverTrigger', {read: PopoverDirective}) filterPopoverDir: PopoverDirective;

  workingValues: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.list) {
      this.syncWorkingFromList();
    }
  }

  get isSelected(): boolean {
    return !!this.list?.selectIn?.[this.field + 'Selected'];
  }

  selectedLabels(): string[] {
    const selected = this.list?.selectIn?.[this.field] || {};
    return this.options
      .filter((option) => !!selected[option])
      .map((option) => this.translationKeyPrefix + '.' + option);
  }

  isWorkingSelected(option: string): boolean {
    return this.workingValues.indexOf(option) > -1;
  }

  toggleWorking(option: string, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const working = [...this.workingValues];
    const index = working.indexOf(option);
    if (checked && index < 0) {
      working.push(option);
    } else if (!checked && index > -1) {
      working.splice(index, 1);
    }
    this.workingValues = working;
    if (this.list) {
      this.list[this.workingField] = working;
    }
  }

  apply(): void {
    this.list?.makeSelectInQuery?.(this.field, this.workingValues, this.maxCount);
    this.filterPopoverDir?.hide();
  }

  clear(): void {
    this.list?.makeSelectInQuery?.(this.field, null);
    this.workingValues = [];
  }

  syncWorkingFromList(): void {
    const working = this.list?.[this.workingField];
    this.workingValues = Array.isArray(working) ? [...working] : [];
  }
}
